import { render, staticRenderFns } from "./actualRoute.vue?vue&type=template&id=67d6ca26&scoped=true&"
import script from "./actualRoute.vue?vue&type=script&lang=js&"
export * from "./actualRoute.vue?vue&type=script&lang=js&"
import style0 from "./actualRoute.vue?vue&type=style&index=0&id=67d6ca26&prod&lang=scss&scoped=true&"
import style1 from "./actualRoute.vue?vue&type=style&index=1&id=67d6ca26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6ca26",
  null
  
)

export default component.exports